import React, { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import Content from '../Content/Content';
import HorizontalSlide from './horizontalSlide';
import './About.css';

var h1 = {
    marginBottom: '3em'
};
var margin = {
    marginBottom: '5em'
};
class About extends Component {
    render () {
        return (
            <Content>
            <div style={margin}>
                <ScrollAnimation animateIn="fadeInDown" animateOnce="true">
                <h1 style={h1}>O Nas</h1>
                </ScrollAnimation>
                <div className="dane">
                    <p>Willa Stara Wozownia w Lusowie to nowo powstały, otwarty na początku sierpnia 2019 roku butikowy hotel, który oferuje swoim Gościom 9 dwuosobowych pokoi urządzonych w eleganckim, nowojorskim stylu, z prywatną łazienką, ogrzewaniem i klimatyzacją. Hotel dysponuje miejscem dla 20 osób. Każdy szczegół jest dopracowany, a do wykończenia wnętrz użyto materiałów najwyższej jakości. Do dyspozycji Gości w każdym pokoju jest telewizor z płaskim ekranem, zestaw do parzenia kawy i herbaty oraz bezpłatne WiFi. Hotel jest idealnym miejscem zarówno na odpoczynek po dniu pełnym spotkań jak i na romantyczne wakacje. Bliskość jeziora lusowskiego i lasu zachęcają do spędzenia tutaj przyjemnych chwil z dala od zgiełku miasta, a jednoczesna bliskość Poznania to atut tego miejsca. Chcemy, by Goście Willi Stara Wozownia czuli się w niej lepiej niż w domu :) </p><br/><br/>
                    <p>Przy tworzeniu tego projektu współpracowaliśmy z wieloma znanymi firmami: <br/>Balma- Noti, Hans Grohe, Legrand, Villeroy&Boch, Ridex <br/><br/>Tuż obok hotelu znajduje się restauracja Stara Wozownia oferująca dania kuchni polskiej i europejskiej. Serwowane są w niej śniadania kontynentalne dla Gości Willi Stara Wozownia oraz lunche i kolacje z karty menu.  </p>
                </div>
                <div className="dane">
                    <HorizontalSlide></HorizontalSlide>
                </div>
            </div>
            </Content>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/About/About.js